import { Transform } from 'class-transformer';
export function TransformWithLVS(transformFn, options = {}) {
    const handler = {
        apply: function (target, _thisArg, argumentsList) {
            const valueOrTransformParams = argumentsList[0];
            if (typeof valueOrTransformParams === 'object' &&
                valueOrTransformParams &&
                'value' in valueOrTransformParams &&
                'key' in valueOrTransformParams &&
                'obj' in valueOrTransformParams &&
                'type' in valueOrTransformParams &&
                'options' in valueOrTransformParams) {
                return target(...argumentsList);
            }
            return target({ value: argumentsList[0], obj: argumentsList[1], type: argumentsList[2], options });
        },
    };
    return Transform(new Proxy(transformFn, handler), options);
}
//# sourceMappingURL=TransformWithLVS.js.map